/**
 * 广告图相关api
 */
import http from './http'

export default class AdApi {

    static getItemByTypeKey(params) {
        return http.httpGet('ad/item', params);
    }
    static addAdClickCount(params) {
        return http.httpGet('ad/addCount', params);
    }

}


// WEBPACK FOOTER //
// ./app/api/ad.api.js